<template>
  <vf-dialog-layout class-wrapper="!p-0" data-scroll-el="filtersPanel">
    <template #title>
      {{ $t.filterAndSort }}
    </template>
    <product-list-filters
      v-bind="$props"
      @change="$emit('change', $event)"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
      @sort="$emit('sort', $event)"
    />
    <template #footer>
      <div class="grid cols-2 gap-4">
        <vf-button data-test-id="dialog-filters-clear-button" variant="secondary" @click="$emit('clear')">
          {{ $t.clearAll }}
        </vf-button>
        <vf-button data-test-id="dialog-filters-apply-button" @click="$emit('resolve')">
          {{ replaceAll($t.applyFilteredResults, { total }) }}
        </vf-button>
      </div>
    </template>
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

export type Props = {
  heading?: string
  total: number
  currency?: string
  filters: FiltersMap
  sortOptions?: { value: SortType, label: string }[]
  filtersQuery?: Record<string, string[]>
  loading?: boolean
  pickupFilters: boolean
  sortState?: string
  storeFilterState?: string
}
export type Emits = {
  clear: []
  change: [payload: { code: string, selected: string[] }]
  remove: [payload: { code: string, id: string }]
  resolve: []
  sort: [payload: string]
}

defineProps<Props>()
defineEmits<Emits>()
</script>
